"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var PropertiesAppBar_1 = require("./PropertiesAppBar");
var RawExampleAppBar_1 = require("./RawExampleAppBar");
var TitleAndClickExampleAppBar_1 = require("./TitleAndClickExampleAppBar");
var StylingExampleAppBar_1 = require("./StylingExampleAppBar");
exports.ComponentAppBarPage = function () { return (React.createElement(common_1.Page, { headerText: "App Bar" },
    React.createElement(common_1.Paragraph, null, "App bar is a special bar on top of an app (justifying its name) containing a title and actions."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleAppBar_1.RawExampleAppBar, null),
    React.createElement(TitleAndClickExampleAppBar_1.TitleAndClickExampleAppBar, null),
    React.createElement(StylingExampleAppBar_1.StylingExampleAppBar, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesAppBar_1.PropertiesAppBar, null))); };
exports.ComponentAppBarPage.displayName = 'ComponentAppBarPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentAppBarPage/ComponentAppBarPage.tsx
// module id = 324
// module chunks = 0